<div class="plan-overview-container">
  <app-loading *ngIf="showLoading"></app-loading>
  <div
    *ngIf="dataIsReady && diet && diet.days[selectedDay].meals"
    class="plan-overview-holder"
  >
    <div class="calendar-holder" id="calendar-box">
      <div
        *ngIf="showPreviousDay"
        class="calendar-previous-day img-holder"
        (click)="previousDay()"
      >
        <img src="assets/plan/previousDay.png" />
      </div>
      <div class="calendar-current-day">
        <div class="calendar-current-day-title">{{ dateTitle }}</div>
      </div>
      <div
        *ngIf="showNextDay"
        class="calendar-next-day img-holder"
        (click)="nextDay()"
      >
        <img src="assets/plan/nextDay.png" />
      </div>
    </div>
    <div
      *ngIf="
        !isBeforeStart &&
        diet.type.type !== 'daily' &&
        diet.type.type !== 'hourly'
      "
      class="plan-overview-top-title"
      (click)="changeTab()"
    >
      {{ title }}
      <img src="assets/plans/edit.svg" />
    </div>
    <div
      *ngIf="isBeforeStart"
      class="plan-overview-top-description-before-start"
      (click)="changeStartDay()"
    >
      {{ currentDay }} روز تا شروع {{ title }}
    </div>
    <div
      *ngIf="
        !isBeforeStart &&
        (diet.type.type === 'daily' || diet.type.type === 'hourly') &&
        showchartY
      "
    >
      <app-plan-overview-fasting-chart
        [change]="changed"
        [dataIsReady]="dataIsReady"
        [title]="title"
        [type]="diet.type.type"
        [isFasting]="isFasting"
        [duration]="duration"
        [endTime]="endTime"
        [fastingTime]="fastingTime"
        [fastingDays]="diet.fasting.fastingDays"
        [dietStartDate]="diet.startDate"
        [dietId]="diet._id"
      ></app-plan-overview-fasting-chart>
    </div>
    <div
      *ngFor="let meal of diet.days[selectedDay].meals; let last = last"
      [ngStyle]="{
        'margin-bottom': last ? '24px' : '0',
        height: lockPlan ? '312px' : 'auto',
        padding: lockPlan ? '0' : '16px 0'
      }"
      class="plan-overview-meal-cell"
    >
      <div *ngIf="lockPlan" class="plan-overview-meal-cell-lock">
        <img src="assets/plan/lock.svg" />
        <div class="plan-overview-meal-cell-lock-shop" (click)="goToShop()">
          برای امروز اشتراک نداری
        </div>
      </div>
      <div
        class="plan-overview-meal-cell-title"
        [ngStyle]="{ padding: lockPlan ? '16px 0' : '0' }"
      >
        پکیج پیشنهادی {{ findMealName(meal.meal) }}
      </div>
      <div
        *ngIf="
          !lockPlan &&
          (meal.status !== 'consumed' || diet.days[selectedDay].isCheatDay) &&
          meal
        "
        class="plan-overview-meal-cell-calorie"
        (click)="openChart(meal)"
      >
        {{ calorieCalculator.calculateMealCalorie(meal) }} کالری
      </div>
      <div *ngIf="!lockPlan">
        <div
          *ngFor="let food of meal.foods; let i = index"
          class="plan-overview-meal-cell-food"
        >
          <div
            class="plan-overview-meal-cell-food-name link-to-recipe"
            *ngIf="food.foodModel?.recipe"
            (click)="goToRecipe(food.foodModel?.recipe)"
          >
            <img src="assets/tabBar/tab3Selected.png" alt="" />
            <span>
              {{ food.foodModel?.name }}
            </span>
          </div>
          <div
            class="plan-overview-meal-cell-food-name"
            *ngIf="!food.foodModel?.recipe"
          >
            {{ food.foodModel?.name }}
          </div>
          <div class="plan-overview-meal-cell-food-amount">
            {{ planService.getFoodAmounts(food) }}
          </div>
        </div>
        <div class="plan-overview-meal-cell-buttons">
          <div
            *ngIf="diet.days[selectedDay].isCheatDay"
            class="plan-overview-meal-cell-cheatday"
            (click)="goToCheatDay()"
          >
            <div class="plan-overview-meal-cell-cheatday-holder">
              <img
                class="plan-overview-meal-cell-cheatday-img"
                src="assets/plan/cheatdayEmoji.svg"
              />
              <div class="plan-overview-meal-cell-cheatday-title">روز آزاد</div>
            </div>
          </div>
          <div
            *ngIf="
              meal.status !== 'consumed' && !diet.days[selectedDay].isCheatDay
            "
            class="plan-overview-meal-cell-add-package"
            (click)="consumed(meal)"
            id="consume-meal-box"
          >
            <div class="plan-overview-meal-cell-add-package-box">
              <img
                class="plan-overview-meal-cell-add-package-img"
                src="assets/plan/plus-white.svg"
              />
              <div class="plan-overview-meal-cell-add-package-title">
                افزودن پکیج
              </div>
            </div>
          </div>
          <div
            *ngIf="
              meal.status !== 'consumed' && !diet.days[selectedDay].isCheatDay
            "
            class="plan-overview-meal-cell-change-package"
            (click)="changePackage(meal.meal)"
            id="change-meal-box"
          >
            <img
              class="plan-overview-meal-cell-change-package-img"
              src="assets/plan/change.png"
            />
            <div class="plan-overview-meal-cell-change-package-title">
              تعویض پکیج
            </div>
          </div>
          <div
            *ngIf="
              meal.status === 'consumed' && !diet.days[selectedDay].isCheatDay
            "
            class="plan-overview-meal-cell-consumed-holder"
          ></div>
        </div>
        <div
          *ngIf="
            meal.status === 'consumed' && !diet.days[selectedDay].isCheatDay
          "
          class="plan-overview-meal-cell-consumed"
        >
          <div
            class="plan-overview-meal-cell-calorie"
            (click)="openChart(meal)"
          >
            {{ calorieCalculator.calculateMealCalorie(meal) }} کالری
          </div>
          <img
            class="plan-overview-meal-cell-consumed-img"
            src="assets/plan/check.svg"
          />
          <div
            class="plan-overview-meal-cell-consumed-change"
            (click)="pendingDialog(meal)"
          >
            تغییر
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="dataIsReady && !diet" class="plan-overview-holder">
    <img class="plan-overview-no-diet-img" src="assets/plans/no-plan.svg" />
    <div class="plan-overview-no-diet-title">
      هنوز برنامه غذایی دریافت نکردید
    </div>
    <div class="plan-overview-no-diet-description">
      جهت دریافت برنامه غذایی به صفحه برنامه‌هایی غذایی بروید
    </div>
  </div>
  <app-ios-bottomsheet
    *ngIf="showIosBottomsheet"
    [input]="iosBottomsheetInput"
  ></app-ios-bottomsheet>
  <!-- <app-bottomsheet *ngIf="showBottomsheet" [type]="bottomsheetInput"></app-bottomsheet> -->
  <div *ngIf="!dataIsReady" class="plan-overview-holder">
    <div class="plan-overview-top-title-holder">
      <ngx-skeleton-loader
        [theme]="{
          top: '0px',
          right: '16px',
          height: '30px',
          width: '150px',
          position: 'absolute',
          'background-color': '#e8eaef'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '4px',
          left: '16px',
          height: '22px',
          width: '100px',
          position: 'absolute',
          'background-color': '#e8eaef'
        }"
      ></ngx-skeleton-loader>
    </div>
    <div class="plan-overview-progress-holder">
      <div class="plan-overview-progress-background"></div>
      <div class="plan-overview-progress" id="planProgressBar"></div>
    </div>
    <div class="calendar-holder" id="calendar-box">
      <div class="calendar-previous-day img-holder">
        <img src="assets/plan/previousDay.png" />
      </div>
      <ngx-skeleton-loader
        [theme]="{
          top: '12px',
          right: 'calc( 50% - 50px )',
          height: '22px',
          width: '100px',
          position: 'absolute',
          'background-color': '#e8eaef'
        }"
      ></ngx-skeleton-loader>
      <div class="calendar-next-day img-holder">
        <img src="assets/plan/nextDay.png" />
      </div>
    </div>
    <div
      *ngFor="let fake of fakeArrayMeals; let last = last"
      [ngStyle]="{ 'margin-bottom': last ? '24px' : '0' }"
      class="plan-overview-meal-cell"
      style="height: 290px"
    >
      <ngx-skeleton-loader
        [theme]="{
          top: '16px',
          right: '16px',
          height: '30px',
          width: '100px',
          position: 'absolute',
          'background-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '56px',
          right: '16px',
          height: '22px',
          width: '70px',
          'margin-top': '16px',
          position: 'absolute',
          'background-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '94px',
          right: '16px',
          height: '22px',
          width: '50px',
          'margin-top': '16px',
          position: 'absolute',
          'background-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '132px',
          right: '16px',
          height: '22px',
          width: '80px',
          'margin-top': '16px',
          position: 'absolute',
          'background-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '170px',
          right: '16px',
          height: '22px',
          width: '100px',
          'margin-top': '16px',
          position: 'absolute',
          'background-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '56px',
          left: '16px',
          height: '22px',
          width: '40px',
          'margin-top': '16px',
          position: 'absolute',
          'background-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '94px',
          left: '16px',
          height: '22px',
          width: '50px',
          'margin-top': '16px',
          position: 'absolute',
          'background-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '132px',
          left: '16px',
          height: '22px',
          width: '70px',
          'margin-top': '16px',
          position: 'absolute',
          'background-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{
          top: '170px',
          left: '16px',
          height: '22px',
          width: '40px',
          'margin-top': '16px',
          position: 'absolute',
          'background-color': '#eceef0'
        }"
      ></ngx-skeleton-loader>
      <div
        style="
          position: absolute;
          width: calc(100% - 32px);
          height: 48px;
          right: 16px;
          top: 250px;
          border-radius: 10px;
          border: 1px solid #0073ff;
          box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.1),
            inset 0px 0.5px 0px 0px rgba(255, 255, 255, 0.5);
        "
      >
        <ngx-skeleton-loader
          [theme]="{
            top: '12px',
            right: 'calc( 50% - 50px )',
            height: '22px',
            width: '100px',
            position: 'absolute',
            'background-color': '#eceef0'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
  <app-plan-overview-notif
    *ngIf="ifshownotif"
    [show]="shownotif"
    [meal]="selectedMealNotif"
    [dietId]="diet._id"
    [date]="selectedDate"
    [day]="selectedDay"
    [isPredeFined]="false"
    [cheatDaycount]="cheatDayCount"
  ></app-plan-overview-notif>
  <app-bottomsheet
    *ngIf="showFoodFactDetail"
    [type]="'foodFact'"
  ></app-bottomsheet>
</div>
